import * as types from './types';
export default {
  updateCurrentRoute(_ref, payload) {
    var {
      commit
    } = _ref;
    commit(types.SET_CURRENT_ROUTE, payload);
  },

  updatePreviousRoute(_ref2, payload) {
    var {
      commit
    } = _ref2;
    commit(types.SET_PREVIOUS_ROUTE, payload);
  }

};